import { DRIVER_LABEL_MAPPING } from './constants';
import type { DriverConfig, DriverMappingConfig } from './types';

export { DRIVER_LABEL_MAPPING, NW_RATING_DEFAULT_TOOLTIP } from './constants';

export function resolveDrivers(...configs: (DriverConfig | undefined)[]): DriverMappingConfig[] {
  const drivers: DriverMappingConfig[] = [];

  for (const config of configs) {
    if (!config?.driver) continue;

    const mapping = DRIVER_LABEL_MAPPING[config.driver];
    if (!mapping) continue;

    drivers.push({
      label: config.label || mapping.label,
      tooltip: config.tooltip,
      marketplaceEntityKey: mapping.marketplaceEntityKey,
      marketplaceEntityDescriptionKey: mapping.marketplaceEntityDescriptionKey,
    });
  }

  return drivers;
}
